import React from "react";

import { type Meta, type Story } from "@storybook/react";

import { AlertButton } from "./alert-button";
import { AlertIconButton } from "./alert-icon-button";
import { DangerButton } from "./danger-button";
import { DangerIconButton } from "./danger-icon-button";
import { NoticeButton } from "./notice-button";
import { PrimaryButton } from "./primary-button";
import { PrimaryIconButton } from "./primary-icon-button";
import { QuickSelectInfoButton } from "./quick-select-info-button";
import { QuickSelectInfoIconButton } from "./quick-select-info-icon-button";
import { QuickSelectNoticeButton } from "./quick-select-notice-button";
import { QuickSelectNoticeIconButton } from "./quick-select-notice-icon-button";
import { SecondaryButton } from "./secondary-button";
import { SecondaryIconButton } from "./secondary-icon-button";
import { TertiaryButton } from "./tertiary-button";
import { TertiaryIconButton } from "./tertiary-icon-button";

// Define metadata for the story
const meta: Meta = {
  title: "Components/Buttons",
  argTypes: {
    onClick: { action: "clicked" },
  },
};

export default meta;

// Template for PrimaryButton
const TemplatePrimary: Story = (args) => <PrimaryButton {...args} />;

// Stories for PrimaryButton
export const Primary = TemplatePrimary.bind({});
Primary.args = {
  children: "Primary Button",
  disabled: false,
};

// Template for SecondaryButton
const TemplateSecondary: Story = (args) => <SecondaryButton {...args} />;

// Stories for SecondaryButton
export const Secondary = TemplateSecondary.bind({});
Secondary.args = {
  children: "Secondary Button",
  disabled: false,
};

// Template for TertiaryButton
const TemplateTertiary: Story = (args) => <TertiaryButton {...args} />;

// Stories for TertiaryButton
export const Tertiary = TemplateTertiary.bind({});
Tertiary.args = {
  children: "Tertiary Button",
  disabled: false,
};

// Template for DangerButton
const TemplateDanger: Story = (args) => <DangerButton {...args} />;

// Stories for DangerButton
export const Danger = TemplateDanger.bind({});
Danger.args = {
  children: "Danger Button",
  disabled: false,
};

// Template for NoticeButton
const TemplateNotice: Story = (args) => <NoticeButton {...args} />;

// Stories for NoticeButton
export const Notice = TemplateNotice.bind({});
Notice.args = {
  children: "Notice Button",
  disabled: false,
};

// Template for QuickSelectNoticeButton
const TemplateQuickSelectNotice: Story = (args) => (
  <QuickSelectNoticeButton {...args} />
);

// Stories for QuickSelectNoticeButton
export const QuickSelectNotice = TemplateQuickSelectNotice.bind({});
QuickSelectNotice.args = {
  children: "Quick Select Notice Button",
  disabled: false,
};

// Template for QuickSelectInfoButton
const TemplateQuickSelectInfo: Story = (args) => (
  <QuickSelectInfoButton {...args} />
);

// Stories for QuickSelectInfoButton
export const QuickSelectInfo = TemplateQuickSelectInfo.bind({});
QuickSelectInfo.args = {
  children: "Quick Select Info Button",
  disabled: false,
};

// Template for PrimaryIconButton
const TemplatePrimaryIcon: Story = (args) => <PrimaryIconButton {...args} />;

// Stories for PrimaryIconButton
export const PrimaryIcon = TemplatePrimaryIcon.bind({});
PrimaryIcon.args = {
  children: "Primary Icon Button",
  disabled: false,
};

// Template for SecondaryIconButton
const TemplateSecondaryIcon: Story = (args) => (
  <SecondaryIconButton {...args} />
);

// Stories for SecondaryIconButton
export const SecondaryIcon = TemplateSecondaryIcon.bind({});
SecondaryIcon.args = {
  children: "Secondary Icon Button",
  disabled: false,
};

// Template for TertiaryIconButton
const TemplateTertiaryIcon: Story = (args) => <TertiaryIconButton {...args} />;

// Stories for TertiaryIconButton
export const TertiaryIcon = TemplateTertiaryIcon.bind({});
TertiaryIcon.args = {
  children: "Tertiary Icon Button",
  disabled: false,
};

// Template for DangerIconButton
const TemplateDangerIcon: Story = (args) => <DangerIconButton {...args} />;

// Stories for DangerIconButton
export const DangerIcon = TemplateDangerIcon.bind({});
DangerIcon.args = {
  children: "Danger Icon Button",
  disabled: false,
};

// Template for AlertButton
const TemplateAlert: Story = (args) => <AlertButton {...args} />;

// Stories for AlertButton
export const Alert = TemplateAlert.bind({});
Alert.args = {
  children: "Alert Button",
  disabled: false,
};

// Template for AlertIconButton
const TemplateAlertIcon: Story = (args) => <AlertIconButton {...args} />;

// Stories for AlertIconButton
export const AlertIcon = TemplateAlertIcon.bind({});
AlertIcon.args = {
  children: "Alert Icon Button",
  disabled: false,
};

// Template for QuickSelectNoticeIconButton
const TemplateQuickSelectNoticeIcon: Story = (args) => (
  <QuickSelectNoticeIconButton {...args} />
);

// Stories for QuickSelectNoticeIconButton
export const QuickSelectNoticeIcon = TemplateQuickSelectNoticeIcon.bind({});
QuickSelectNoticeIcon.args = {
  children: "Quick Select Notice Icon Button",
  disabled: false,
};

// Template for QuickSelectInfoIconButton
const TemplateQuickSelectInfoIcon: Story = (args) => (
  <QuickSelectInfoIconButton {...args} />
);

// Stories for QuickSelectInfoIconButton
export const QuickSelectInfoIcon = TemplateQuickSelectInfoIcon.bind({});
QuickSelectInfoIcon.args = {
  children: "Quick Select Info Icon Button",
  disabled: false,
};
